import { render, staticRenderFns } from "./Tuiles.vue?vue&type=template&id=2b91607e&"
import script from "./Tuiles.vue?vue&type=script&lang=js&"
export * from "./Tuiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports